<template>
  <div class="page">
    <div class="aleph-item-wrap">
      <div>
        <van-image
          fit="cover"
          class="cover"
          :src="`${ALEPH_BOOK_COVER_URL}${
            item.isbn ? item.isbn.split('#')[0] : item.issn
          }/cover`"
          alt="暂无封面"
        >
          <template v-slot:loading>
            <img
              width="100%"
              height="100%"
              :src="defaultCoverImg"
              alt="暂无封面"
            />
          </template>
          <template v-slot:error>
            <img
              width="100%"
              height="100%"
              :src="defaultCoverImg"
              alt="暂无封面"
            />
          </template>
        </van-image>
      </div>
      <div class="text-wrap">
        <div class="text" v-if="item.mTitle">
          <span class="tit">题名：</span>{{ item.mTitle }}
        </div>
        <div class="text" v-if="item.title.resource_blztm">
          {{ item.title.resource_blztm }}
        </div>
        <div class="text" v-if="item.mAuthor.length > 0">
          <span class="tit">责任者：</span>{{ item.mAuthor.join(";") }}
        </div>
        <div class="text" v-if="item.publish && item.publish != 'null'">
          <span class="tit">出版：</span
          >{{
            `${
              item.publishAddress && item.publishAddress != "null"
                ? item.publishAddress + ":"
                : ""
            }${item.publish.split("#")[0]}${
              item.publicationYear ? "," + item.publicationYear : ""
            }`
          }}
        </div>
        <div class="text" v-if="item.isbn && item.isbn != 'null'">
          <span class="tit">ISBN：</span>{{ item.isbn.split("#")[0] }}
        </div>
        <div class="text" v-if="item.issn && item.issn != 'null'">
          <span class="tit">ISSN：</span>{{ item.issn }}
        </div>
        <div
          class="text"
          v-if="
            item.resourceFmt == 'CF' &&
            item.detailData.resource_dzzydwyfw &&
            item.detailData.resource_dzzydwyfw != 'null'
          "
        >
          <span class="tit">电子书链接：</span>
          <a class="link" :href="item.detailData.resource_dzzydwyfw">查看</a>
        </div>
        <div
          class="text"
          v-if="
            item.resourceFmt == 'CF' && item.sfxLink && item.sfxLink != 'null'
          "
        >
          <span class="tit">SFX获取：</span>
          <a class="link" :href="item.sfxLink">查看</a>
        </div>
      </div>
    </div>
    <div class="hold-request-wrap" v-if="itemDetailList.length > 0">
      <div v-for="(item, index) in itemDetailList" :key="index">
        <div v-show="item.display" class="hold-request-item">
          <div class="item-left">
            <div class="text-wrap">
              <div
                v-text="
                  `${item.temporaryLibraryName}-${item.temporaryLocationName}`
                "
              ></div>
            </div>
            <div style="margin-top: 5px">
              <van-tag plain type="primary">{{ item.itemStatusName }}</van-tag>
              <van-tag
                v-if="item.callNo"
                plain
                type="danger"
                style="margin-left: 10px"
                >{{ item.callNo }}</van-tag
              >
            </div>
          </div>
          <div
            v-show="item.requestFlag"
            class="btn"
            @click="handleLibShow(item)"
          >
            预 约
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="libShow" position="bottom">
      <div class="popup-content">
        <div class="pop-title">
          <van-icon class="icon" name="location" />
          <span class="tit">请选择取书点</span>
        </div>
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item
            @change="handleMenuChange"
            v-model="pickAddrItem.value"
            :options="locColumns"
          />
        </van-dropdown-menu>
        <div class="pop-title">
          <van-icon class="icon" name="todo-list" />
          <div class="tit-wrap">
            <div class="tit1">对该书最大感兴趣时间</div>
            <div class="tit2">（超过此日期预约将自动失效）</div>
          </div>
        </div>
        <van-datetime-picker
          ref="datePicker"
          :visible-item-count="5"
          :show-toolbar="false"
          v-model="expectDate"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
        />
        <div class="btn-wrap">
          <van-button class="btn" @click="libShow = false">取 消</van-button>
          <van-button
            class="btn"
            type="primary"
            @click="handleAlephHoldRequestSure"
            >确 认</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  shrfidSelectItemListGet,
  shrfidRequestValidGet,
  shrfidAddRequest,
} from "@/api/book-search";
import { getSessionStorage } from "@/utils";
import {
  STATUS_CODE_OK,
  TOAST_STAY_TIME,
  ALEPH_BOOK_COVER_URL,
} from "@/config";
export default {
  name: "AlephHoldDetail",
  data() {
    return {
      defaultCoverImg: require("@/assets/images/default-img.jpg"),
      ALEPH_BOOK_COVER_URL,
      item: {},
      locItem: {},
      itemDetailList: [],
      libShow: false,
      locColumns: [],
      minDate: new Date(),
      maxDate: new Date(),
      pickAddrItem: {
        value: "",
        text: "",
      }, // 取书点
      expectDate: new Date(), // 取书日期
    };
  },
  async created() {
    this.item = getSessionStorage("queryParam");
    this.handleAlephItemDataGet();
  },
  methods: {
    // 学术搜索馆藏列表获取
    async handleAlephItemDataGet() {
      const that = this;
      let { data } = await shrfidSelectItemListGet({
        catalogueId: that.item.id,
      });
      if (data.code === STATUS_CODE_OK) {
        that.itemDetailList = data.data.list || [];
      }
    },
    // 验证获取图书资格，如有资格返回取书地点列表
    async handleLibShow(item) {
      const { data } = await shrfidRequestValidGet({
        itemBarcode: item.barcode,
      });
      if (data.code === STATUS_CODE_OK) {
        this.locItem = item;
        this.locColumns = data.data.pickupLocationRespDTOS.map((addr) => {
          return { ...addr, text: addr.name, value: addr.code };
        });
        this.maxDate = this.$moment()
          .add(data.data.requestDateRange, "days")
          .toDate();
        this.pickAddrItem = {
          value: this.locColumns[0]?.value,
          text: this.locColumns[0]?.text,
        };
        this.libShow = true;
        this.$nextTick(() => {
          let monmentValue = this.$moment().add(
            data.data.requestDateRange,
            "days"
          );
          window.setTimeout(() => {
            this.expectDate = monmentValue.toDate();
          }, 100);
        });
      }
    },
    // 取书地点改变事件
    handleMenuChange(value) {
      this.pickAddrItem.text =
        this.locColumns.find((loc) => loc.value == value).text || "";
    },
    // 预约确认
    async handleAlephHoldRequestSure() {
      if (!this.pickAddrItem.value) {
        this.$notify({
          type: "warning",
          message: "请选择取书点",
          duration: TOAST_STAY_TIME,
        });
        return;
      }
      await this.$dialog.confirm({
        title: "提示",
        message: `取书地点【${
          this.pickAddrItem.text
        }】，对该书最大感兴趣时间【${this.$moment(this.expectDate).format(
          "YYYY-MM-DD"
        )}】，是否预约？`,
        confirmButtonText: "预 约",
        confirmButtonColor: "#1989fa",
      });
      this.handleAlephHoldRequest();
    },
    // 预约
    async handleAlephHoldRequest() {
      const { data } = await shrfidAddRequest({
        itemBarCode: this.locItem.barcode,
        pickupLocation: this.pickAddrItem.value,
        expectDate: this.$moment(this.expectDate).format("YYYY-MM-DD"),
      });
      if (data.code === STATUS_CODE_OK) {
        this.$notify({
          type: "success",
          message: "预约成功",
          duration: TOAST_STAY_TIME,
        });
        this.$router.back();
        this.libShow = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .aleph-item-wrap {
    display: flex;
    padding: 10px;
    background-color: #fff;
    &:last-child {
      margin-bottom: 0;
    }
    .cover {
      width: 100px;
      height: 156px;
      margin-right: 10px;
    }
    .text-wrap {
      flex: 1;
      width: 0;
      .text {
        margin-bottom: 6px;
        color: #777;
        .tit {
          color: #000;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .normal-row {
    display: flex;
    padding: 0 10px 10px 10px;
    margin-bottom: 10px;
    background-color: #fff;
    .tit {
      flex: none;
      color: #000;
      &.white {
        color: #fff;
      }
    }
    .con {
      flex: 1;
      width: 0;
      color: #777;
      display: flex;
      flex-wrap: wrap;
      .ids {
        margin-right: 5px;
        &:last-child {
          margin-right: 0;
        }
      }
      &.collapse {
        line-height: 22px;
        padding-right: 16px;
        position: relative;
      }
      .collapse-wrap {
        display: flex;
        align-items: center;
        .icon {
          margin-left: 3px;
        }
      }
      .arrow-down,
      .arrow-up {
        position: absolute;
        right: 0;
        bottom: 3px;
      }
    }
  }
  .back-issue {
    background-color: #fff;
    padding: 10px;
    color: #999;
  }
  .hold-request-wrap {
    padding: 0 10px;
    background-color: #fff;
    .hold-request-item {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      color: #666;
      .item-left {
        flex: 1;
        .text-wrap {
          display: flex;
          align-items: center;
        }
      }
      &:last-child {
        border-bottom: none;
      }
      .btn {
        background-color: #07c160;
        color: #fff;
        padding: 6px 12px;
        border-radius: 2px;
        font-size: 12px;
      }
    }
  }
  .popup-content {
    background-color: #fff;
    padding: 0 10px 40px 10px;
    ::v-deep .van-dropdown-menu__item {
      justify-content: flex-start;
    }
  }
  .pop-title {
    padding: 20px 0 15px 0;
    font-size: 16px;
    color: #000;
    display: flex;
    align-items: flex-start;
    .icon {
      font-size: 18px;
    }
    .tit-wrap {
      .tit1 {
        padding-left: 10px;
      }
      .tit2 {
        font-size: 14px;
        color: #666;
      }
    }
  }
  .btn-wrap {
    margin-top: 10px;
    display: flex;
    align-items: center;
    padding: 10px;
    .btn {
      flex: 1;
      margin: 0 10px;
    }
  }
}
</style>
